// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A tool to display a single, or series of JPG, PNG, GIF, SVG images, Datawrapper and/or Flourish charts with a customised menu label feature.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Graphic embedder",
  id: "graphic-embed",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/graphic-embed/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "GraphicEmbedConfigTool" */ "app/components/tools/GraphicEmbedConfigTool/GraphicEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["GraphicEmbedConfigTool"]
  })
};

export default CONFIG;
